import { render } from "./view-medical-records.vue?vue&type=template&id=4a8f00bd"
import script from "./view-medical-records.vue?vue&type=script&lang=js"
export * from "./view-medical-records.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__